const API_LOGIN_URL = process.env.REACT_APP_API_LOGIN_URL;

export async function loginRequest(email, password) {
  const response = await fetch(API_LOGIN_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json();
  return data;
}
